module.exports = __webpack_public_path__ + "static/media/quezishan.38ddc905.webp";